<template>
  <div style="margin:20px">
    <FiPageRail title="Actuals Hours By Booking Report"/>

    <div style="font-size: 22px; font-weight: bold; position: relative; margin: 30px" class="d-flex align-items-center justify-content-center">
      <a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"/>
      &nbsp;to&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_toDate" :config="options" :placeholder="details_toDate"/>
      &nbsp;&nbsp;&nbsp;<b-button v-on:click.prevent="load_data(false)">Get Results</b-button>
      &nbsp;&nbsp;&nbsp;<b-button v-on:click.prevent="load_data(true)" :disabled="loading">Pull New Data</b-button>
    </div>

    <div v-if="summary.total_cnt && !loading">
      <div class="row" style="margin: 30px 10px 30px 10px; font-weight: bold; font-size: 22px;">
        <div @click="filter_by_status('')" class="col" style="border: 1px solid grey;">{{items.length}} of {{summary.total_cnt}}</div>
        <div>&nbsp;&nbsp;<b-button size="md" variant="success" @click="download">Download</b-button></div>
      </div>
    </div>

    <div>
      <b-table :busy="loading" sticky-header="70vh" bordered :items="items" :fields="fields" style="font-size:18px"
               :current-page="currentPage" :tbody-tr-class="get_row_color"
               :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>

        <template slot="processed_time" slot-scope="row">
          {{row.item.processed_time | formatDateTimeSmall}}
          <span v-if="row.item.movement_vehicle_id.includes('reprocess')">(reprocessed)</span>
        </template>

        <template slot="logStartTime" slot-scope="row">
          {{row.item.logStartTime | formatDateTimeSmall}}
        </template>

        <template slot="logEndTime" slot-scope="row">
          {{row.item.logEndTime | formatDateTimeSmall}}
        </template>

        <template slot="hosStatusType" slot-scope="row">
          {{row.item.hosStatusType | prettyProperty}}
        </template>

        <template slot="driverName" slot-scope="row">
          <a target='_blank' style="font-weight:bold" :href="row.item.hosLink">{{ row.item.driverName }}</a>
        </template>

        <template slot="location" slot-scope="row">
          <a target='_blank' style="font-weight:bold" :href="'https://www.google.com/maps/search/?api=1&query=' + row.item.logRecordedLocation.latitude + ',' + row.item.logRecordedLocation.longitude">location</a>
        </template>

        <template slot="details" slot-scope="row">
          <b-button size="sm" @click="row.toggleDetails">
            {{ row.detailsShowing ? '-' : '+' }}
          </b-button>
        </template>

        <template slot="row-details" slot-scope="row">
          <b-card style="text-align: left;">
            <div class="row" v-for="payroll_result in row.item.payroll_results">
              <div class="col">{{payroll_result.driver}}</div>
              <div class="col">{{payroll_result.payrollHours}}</div>
              <div class="col">{{payroll_result.actualPayrollStartDateTime | formatDateTimeSmall}}</div>
              <div class="col">{{payroll_result.actualPayrollFinishDateTime | formatDateTimeSmall}}</div>
            </div>
          </b-card>
        </template>
      </b-table>
      <b-row>
        <b-col>
          <b-pagination
              v-model="currentPage"
              :total-rows="items.length"
              :per-page="perPage"
              align="center"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

import {api_url, get_hos_by_booking_report} from '../networking/tbn_apis'
import {mapState} from "vuex";
import moment from 'moment'
import {justDate} from "@/helpers/dates";
import axios from 'axios';

export default {
  name: 'actuals_hours_by_booking_report_tbn',
  components: {
  },

  data() {
    return {
      remarks_filter: '',
      items: [],
      items_full: [],
      summary: [],
      loading: false,
      details_fromDate: justDate(moment().subtract(1, 'days')),
      details_toDate: justDate(moment().subtract(1, 'days')),
      selected_status: '',
      selected_driver: '',
      driver_options: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      pages: [],
      type_options: [
        { value: '', text: 'All' },
        { value: 'onDuty', text: 'On Duty' },
        { value: 'offDuty', text: 'Off Duty' },
        { value: 'driving', text: 'Driving' },
        { value: 'sleeperBed', text: 'Sleeper Bed' },
        { value: 'yardMove', text: 'Yard Move' },
        { value: 'personalConveyance', text: 'Personal Conveyance' },
      ],
      fields_all: [],
      fields: [
        { key: 'details', sortable: false, thStyle: { width: "20px" }},
        { key: 'bookingID', label: 'Booking ID', sortable: true},
        { key: 'total_hours', label: 'Total Hours', sortable: true},
      ]
      ,
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(90, 'days'),
        maxDate: moment().add(0, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
        toolbarPlacement: 'top',
      },

    }
  },

  async created() {
    this.fields_all = this.fields
    this.check_features()
  },
  methods: {
    async check_features() {
    },
    async load_data(reprocess) {
      this.loading = true
      try {
        const {value: { data = [] } } = await get_hos_by_booking_report(this.user.tenant,moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
            moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'), reprocess)
        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
        this.items_full = data.results
        this.filter_results()
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }
      this.loading = false
    },
    async download(){
      this.$emit('showAlert', 'processing download request', 'info', 5000)
      axios.defaults.headers.common.Accept = {}
      axios.post(
          `${api_url}tbn/reports/actuals/hoursByBooking/download`,
          {
            tenant: this.user.tenant,
            fromDate: moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
            toDate: moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
          }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('jwt')}`,
              Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            },
            responseType: 'blob'
          }
      ).then((response) => {
        axios.defaults.headers.common.Accept = 'application/json'
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
            'download',
            `hours-by-booking-${this.details_fromDate}-${this.details_toDate}.csv`
        )
        document.body.appendChild(link)
        link.click()
        this.$emit('showAlert', 'download complete', 'success', 5000)
      }).catch(e => {
        axios.defaults.headers.common.Accept = 'application/json'
        this.$emit('showAlert', 'alert data could not be downloaded.', 'danger')
      })
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
      this.details_toDate = moment(this.details_toDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    },
    toggle_div(item,field) {
      item[field] = !item[field];
      this.$forceUpdate();
    },
    get_row_color(item, type) {
      if (item != null)
        return item.hosStatusType
    },
    filter_by_status(status) {
      this.selected_status = status
    },
    filter_results() {
      this.items = this.items_full

      if (this.selected_driver != '')
        this.items = this.items.filter(item => (item.driverID == this.selected_driver))

      if (this.selected_status != '')
        this.items = this.items.filter(item => (item.hosStatusType == this.selected_status))

      if (this.remarks_filter != '') {
        const val = this.remarks_filter
        this.items = this.items.filter(item => (this.contains(item.remark, val)))
      }
    },
    contains(val1, val2) {
      if (val1 != null) {
        return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
      }
      return false;
    }

  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
    selected_driver(target_from_date) {
      this.filter_results();
    },
    selected_status(target_from_date) {
      this.filter_results();
    },
    remarks_filter() {
      this.filter_results()
    },
    details_toDate(target_to_date) {
      const days = moment(this.details_toDate, 'MM-DD-YYYY').diff(moment(this.details_fromDate, 'MM-DD-YYYY'),'days')
      if (days > 31) {
        alert("please limit date range to 1 month or less")
        this.details_fromDate = justDate(moment(this.details_toDate, 'MM-DD-YYYY').subtract(31, 'days'))
      }
    },
    details_fromDate(target_from_date) {
      const days = moment(this.details_toDate, 'MM-DD-YYYY').diff(moment(this.details_fromDate, 'MM-DD-YYYY'),'days')
      if (days > 31) {
        alert("please limit date range to 1 month or less")
        this.details_toDate = justDate(moment(this.details_fromDate, 'MM-DD-YYYY').add(31, 'days'))
      }
    },

  }
}
</script>

<style>
.onDuty { background-color: rgba(251, 149, 86,0.4)}
.offDuty {background-color: rgba(101, 114, 129,0.4)}
.driving { background-color: rgba(13, 176, 16,0.4)}

.onDuty td { background-color: rgba(251, 149, 86,0.4)}
.offDuty td {background-color: rgba(101, 114, 129,0.4)}
.driving td { background-color: rgba(13, 176, 16,0.4)}


</style>

